import React from "react";
import { ProjectTopBanner } from "../components/ProjectTopBanner";
import { projectOperationsList } from "../constants/project.constants";
import {
  Box,
  Card,
  CardContent,
  Grid2 as Grid,
  List,
  ListItem,
  ListItemText,
  Rating,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useProjectContext } from "../context";
import dayjs from "configs/dayjs.config";

import { dateTimeFormat } from "constants/componentsConstants";
import { PageTitle } from "components/PageMeta/PageTitle";
import { pageName } from "constants/pageNames";
import { FlexBox } from "components/Wrappers/FlexBox/FlexBox";

export const PreviewProject = () => {
  const { previewProject: record } = useProjectContext();
  return (
    <>
      <PageTitle pageName={pageName.enquiry.previewEnquiry} />
      <ProjectTopBanner
        buttonType="back"
        enquiryOperationsParam={projectOperationsList.listProject}
      />
      <Card>
        <CardContent>
          <Grid container spacing={5}>
            <Box>
              <Typography variant="h6">Project Information</Typography>
              <List>
                <ListItem>
                  <ListItemText
                    primary="Project Name"
                    secondary={record.projectName}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Project Type"
                    secondary={record.projectType}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Project Contact No"
                    secondary={record.clientContactNo}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Project Email"
                    secondary={record.clientEmail}
                  />
                </ListItem>
                <ListItem>
                  <FlexBox flexDirection={"column"}>
                    <Typography component="legend">Weightage</Typography>
                    <Rating value={record.weightage} size="large" readOnly />
                  </FlexBox>
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Delivery Date"
                    secondary={dayjs(record.deliveryDate).format(
                      dateTimeFormat.date
                    )}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Budget" secondary={record.budget} />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Project Address"
                    secondary={record.clientAddress}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="BDC"
                    secondary={
                      record.createdBy +
                      " / [" +
                      dayjs(record.createdOn).format(dateTimeFormat.date) +
                      "]"
                    }
                  />
                </ListItem>
              </List>
            </Box>

            <Box flexGrow={1}>
              <Typography variant="h6">POC Information</Typography>
              <TableContainer>
                <Table>
                  <TableHead>
                    {record.pocList.map((poc, index) => (
                      <TableRow key={index}>
                        <TableCell>
                          <Box>POC : {index + 1}</Box>
                          <Box>Name : {poc.pocName}</Box>
                          <Box>Designation : {poc.pocDesignation}</Box>
                          <Box>Contact : {poc.pocContact}</Box>
                          <Box>Email : {poc.pocEmail}</Box>
                          <Box>Contact Other 1 : {poc.pocContactOther}</Box>
                          <Box>Email Other 1 : {poc.pocEmailOther}</Box>
                          <Box>Contact Other 2 : {poc.pocContactOther2}</Box>
                          <Box>Email Other 2 : {poc.pocEmailOther2}</Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableHead>
                </Table>
              </TableContainer>
            </Box>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
};
